function whenDocumentReady(callback) {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback);
    } else {
        callback();
    }
}

/** After AJAX add: refresh cart UI and open sidebar drawer (same flow as theme Product form). */
function npbpOpenCartDrawerAfterAdd() {
    if (
        typeof theme !== 'undefined' &&
        theme.Cart &&
        theme.Cart.prototype &&
        typeof theme.Cart.prototype._onProductAdded === 'function'
    ) {
        theme.Cart.prototype._onProductAdded();
        return;
    }
    var drawer = document.querySelector('#sidebar-cart');
    if (!drawer) return;
    var cartBase = window.routes && window.routes.cartUrl ? window.routes.cartUrl : '/cart';
    fetch(cartBase + '?view=drawer&timestamp=' + Date.now(), {
        credentials: 'same-origin',
        method: 'GET',
    })
        .then(function (r) {
            return r.text();
        })
        .then(function (html) {
            var temp = document.createElement('div');
            temp.innerHTML = html;
            var nextDrawer = temp.querySelector('#sidebar-cart');
            if (!nextDrawer) {
                drawer.classList.add('show');
                document.body.classList.add('show_overlay');
                return;
            }
            [['.Drawer__Header', '.Drawer__Header'], ['.Drawer__Main', '.Drawer__Main'], ['.Drawer__Footer', '.Drawer__Footer']].forEach(function (sel) {
                var cur = drawer.querySelector(sel[0]);
                var nxt = nextDrawer.querySelector(sel[1]);
                if (cur && nxt) cur.innerHTML = nxt.innerHTML;
            });
            var nextSettings = nextDrawer.getAttribute('data-section-settings');
            if (nextSettings) {
                drawer.setAttribute('data-section-settings', nextSettings);
            }
            try {
                var cartResult = JSON.parse(nextDrawer.getAttribute('data-section-settings') || '{}');
                var headerCartCount = document.querySelector('.header_cart_count');
                var headerTotalPriceEl = document.querySelector('.cart_total_price');
                if (headerCartCount && typeof cartResult.itemCount !== 'undefined') {
                    headerCartCount.textContent = cartResult.itemCount;
                    headerCartCount.classList.toggle('hide', !(cartResult.itemCount > 0));
                }
                if (
                    headerTotalPriceEl &&
                    typeof theme !== 'undefined' &&
                    theme.Currency &&
                    typeof theme.Currency.formatMoney === 'function' &&
                    typeof cartResult.totalPrice !== 'undefined'
                ) {
                    headerTotalPriceEl.textContent = theme.Currency.formatMoney(cartResult.totalPrice, theme.moneyFormat);
                }
            } catch (err) {}
            drawer.classList.add('show');
            document.body.classList.add('show_overlay');
        })
        .catch(function () {
            drawer.classList.add('show');
            document.body.classList.add('show_overlay');
        });
}

function initBundleTabProductSection(section) {
    if (section.dataset.npbpBtpInitialized === 'true') return;
    section.dataset.npbpBtpInitialized = 'true';

        // Remove extra DOM element logic
        function removeExtraEl(section, tabWrapper, contentWrapper, tabSelector, contentSelector) {
            const tabWrappers = section.querySelectorAll(tabWrapper);
            if (!tabWrappers.length) return;
            tabWrappers.forEach(w => {
                w.querySelectorAll(contentSelector).forEach(el => el.remove());
            });
            
            const contentWrappers = section.querySelectorAll(contentWrapper);
            if (!contentWrappers.length) return;
            contentWrappers.forEach(w => {
                w.querySelectorAll(tabSelector).forEach(el => el.remove());
            });
        }

        // Align product card info height logic
        function alignProductCardInfoHeight() {
            const activeCards = section.querySelectorAll('.npbp-btp-group-products__cards.active');
            if (!activeCards.length) return;

            activeCards.forEach(cards => {
                const root = cards.closest('.npbp-btp-group__products') || section;
                root.style.setProperty('--max-prod-info-height', 'auto');
            });

            activeCards.forEach(cards => {
                const productIntros = cards.querySelectorAll('.npbp-btp-group-product__intro');
                if (!productIntros.length) return;
                let maxH = 0;
                productIntros.forEach(el => {
                    const h = el.offsetHeight || el.getBoundingClientRect().height || el.scrollHeight;
                    if (h > maxH) maxH = h;
                });
                const root = cards.closest('.npbp-btp-group__products') || section;
                root.style.setProperty('--max-prod-info-height', maxH + 'px');
            });
        }

        function alignProductCardInfoHeightAsync() {
            requestAnimationFrame(() => {
                requestAnimationFrame(alignProductCardInfoHeight);
            });
        }

        // Tab change logic
        function tabChange(section, tabEls, contentEls, id) {   
            const tabs = section.querySelectorAll(tabEls);
            const contents = section.querySelectorAll(contentEls);
            if (!tabs.length || !contents.length) return;

            if (tabs.length && contents.length) {
                tabs[0].classList.add('active');

                contents.forEach(item => {
                    if (tabs[0].getAttribute(id) === item.getAttribute(id)) {
                        item.classList.add('active');
                    }
                });
            }

            tabs.forEach(tabItem => {     
                tabItem.addEventListener('click', function () {

                    tabs.forEach(t => t.classList.remove('active'));

                    tabItem.classList.add('active');

                    contents.forEach(contentItem => {
                        if (tabItem.getAttribute(id) === contentItem.getAttribute(id)) {
                            contentItem.classList.add('active');
                        } else {
                            contentItem.classList.remove('active');
                        }
                    });

                    alignProductCardInfoHeightAsync();

                });
            });
        }

        // Init sticky tabs logic
        function initStickyTabs() {
            const tabs = section.querySelector('.npbp-bundle-tab-product__tabs');
            const allProducts = section.querySelectorAll('.npbp-btp-group-products__cards');

            if (!tabs || !allProducts.length) return;

            function getSectionPaddingTop() {
                return parseInt(getComputedStyle(section).paddingTop, 10) || 0;
            }

            function getVisibleProducts() {
                return Array.from(allProducts).find(el => {
                return getComputedStyle(el).display !== 'none';
                });
            }

            function onScroll() {
                const paddingTop = getSectionPaddingTop();
                const sectionTop = section.getBoundingClientRect().top + window.scrollY;
                const triggerStart = sectionTop + paddingTop;
                const scrollY = window.scrollY;

                const visibleProducts = getVisibleProducts();

                if (!visibleProducts) {
                tabs.classList.remove('fixed');
                return;
                }

                const productsTop = visibleProducts.getBoundingClientRect().top;

                if (scrollY >= triggerStart && productsTop > 0) {
                tabs.classList.add('fixed');
                } else {
                tabs.classList.remove('fixed');
                }
            }

            const observer = new MutationObserver(() => {
                onScroll();
            });

            allProducts.forEach(el => {
                observer.observe(el, {
                attributes: true,
                attributeFilter: ['style', 'class'],
                });
            });

            window.addEventListener('scroll', onScroll, { passive: true });
            onScroll();
        }

        // Bind tab trigger first child logic
        function bindTabTriggerFirstChild(tabEl, childTabsElOrList) {
            if (!tabEl || !childTabsElOrList) return;
            function getFirstChild() {
                if (childTabsElOrList.length !== undefined) {
                    return childTabsElOrList[0] || null;
                }
                if (typeof childTabsElOrList.querySelector === 'function') {
                    return childTabsElOrList.querySelector('.npbp-btp-group-products__tab-trigger') || null;
                }
                return null;
            }
            tabEl.addEventListener('click', () => {
                const first = getFirstChild();
                if (first && typeof first.click === 'function') first.click();
            });
        }

        // Click tab scroll into center logic
        function bindScrollIntoCenter(section, scrollerSelector, triggerSelector) {
            const scroller = section.querySelector(scrollerSelector);
            if (!scroller) return;
            const triggers = section.querySelectorAll(triggerSelector);
            if (!triggers.length) return;
            if(window.innerWidth >= 769) return;
            
            function center(tab) {
                requestAnimationFrame(() => {
                    const tabCenter = tab.offsetLeft + tab.offsetWidth / 2;
                    const scrollerCenter = scroller.clientWidth / 2;

                    scroller.scrollTo({
                        left: tabCenter - scrollerCenter,
                        behavior: 'smooth'
                    });
                });
            }

            triggers.forEach(tabEl => {
                tabEl.addEventListener('click', () => center(tabEl));
            });
        }

        removeExtraEl(section, '.npbp-bundle-tab-product__tabs', '.npbp-bundle-tab-product__contents', '.npbp-btp-group__block-tab-trigger', '.npbp-btp-group__block-content');
        removeExtraEl(section, '.npbp-bundle-tab-product__tabs', '.npbp-btp-group__products', '.npbp-btp-group__block-tab-trigger', '.npbp-btp-group__products');
        removeExtraEl(section, '.npbp-btp-group__tabs', '.npbp-btp-group__products', '.npbp-btp-group-products__tab-trigger', '.npbp-btp-group-products__cards');

        tabChange(section, '.npbp-btp-group__block-tab-trigger', '.npbpgb-content', 'data-npbpg-id');
        tabChange(section, '.npbp-btp-group-products__tab-trigger', '.npbp-btp-group-products__cards', 'data-npbpgps-id');

        alignProductCardInfoHeightAsync();

        bindScrollIntoCenter(section, '.npbp-bundle-tab-product__tabs', '.npbp-btp-group__block-tab-trigger');

        // Bind tab trigger first child logic
        const parentTabs = section.querySelectorAll('.npbp-btp-group__block-tab-trigger');
        parentTabs.forEach(tab => {
            const targetId = tab.getAttribute('data-npbpg-id');
            const container = section.querySelector('.npbpgb-content[data-npbpg-id="' + targetId + '"]');
            if (!container) return;
            const childTriggers = container.querySelectorAll('.npbp-btp-group-products__tab-trigger');
            if (!childTriggers.length) return;
            bindTabTriggerFirstChild(tab, childTriggers);
        });

        initStickyTabs();

        // ATC: capture-phase delegation — card is wrapped in <a>; prevents link navigation
        // from stealing the click after refresh / theme editor section reload (shopify:section:load).
        section.addEventListener(
            'click',
            function (e) {
                var atcBtn = e.target.closest && e.target.closest('.atc-btn');
                if (!atcBtn || !section.contains(atcBtn)) return;

                e.preventDefault();
                e.stopPropagation();
                if (typeof e.stopImmediatePropagation === 'function') {
                    e.stopImmediatePropagation();
                }

                var buttonElement = atcBtn.querySelector('.icon-cart');
                var loaderElement = atcBtn.querySelector('.loader');
                if (buttonElement) buttonElement.style.display = 'none';
                if (loaderElement) loaderElement.classList.remove('hide');

                var variantId = atcBtn.getAttribute('data-variant-id');
                if (!variantId) {
                    if (buttonElement) buttonElement.style.display = 'block';
                    if (loaderElement) loaderElement.classList.add('hide');
                    return;
                }

                var formData = {
                    items: [
                        {
                            id: variantId,
                            quantity: 1,
                        },
                    ],
                };
                fetch('/cart/add.js', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                })
                    .then(function (response) {
                        return response.json().then(
                            function (json) {
                                return { ok: response.ok, json: json };
                            },
                            function () {
                                return { ok: false, json: null };
                            }
                        );
                    })
                    .then(function (result) {
                        var json = result.json;
                        var failed =
                            !result.ok ||
                            (json && json.errors) ||
                            (json && typeof json.status === 'number' && json.status >= 400);
                        if (failed) return;
                        npbpOpenCartDrawerAfterAdd();
                    })
                    .finally(function () {
                        if (buttonElement) buttonElement.style.display = 'block';
                        if (loaderElement) loaderElement.classList.add('hide');
                    });
            },
            true
        );
}

whenDocumentReady(function () {
    document.querySelectorAll('.npbp-bundle-tab-product').forEach(initBundleTabProductSection);
});

document.addEventListener('shopify:section:load', function (event) {
    var host = event.target;
    if (!host || typeof host.querySelectorAll !== 'function') return;
    host.querySelectorAll('.npbp-bundle-tab-product').forEach(initBundleTabProductSection);
});
